<template>
  <CModal
    :title="'Ficha del Vehiculo - ' + (vehicle.code || '')"
    color="info"
    :show.sync="showModal"
    size="xl"
  >
    <CRow>
      <CCol :md="hasImages ? 7 : 12" v-if="hasImages">
        <h5 class="section-title">Fotos del vehiculo</h5>
        <div class="image-viewer">
          <img class="main-image" :src="activeImageUrl" alt="Foto del vehiculo" />
          <div class="mt-2 text-right" v-if="activeImageId > 0">
            <CButton color="danger" size="sm" @click="deleteImage(activeImageId)">Eliminar foto seleccionada</CButton>
          </div>
          <div class="thumbs" v-if="images.length > 1">
            <button
              v-for="(image, index) in images"
              :key="image.url + '-' + index"
              type="button"
              class="thumb-btn"
              :class="{ active: image.url === activeImageUrl }"
              @click="setActiveImage(image)"
            >
              <img :src="image.url" alt="Miniatura" />
            </button>
          </div>
        </div>
      </CCol>

      <CCol :md="hasImages ? 5 : 12">
        <div class="sheet-row"><b>Nombre:</b> {{ safeValue(vehicle.name) }}</div>
        <div class="sheet-row"><b>Codigo:</b> {{ safeValue(vehicle.code) }}</div>
        <div class="sheet-row"><b>Codigo anterior:</b> {{ safeValue(vehicle.last_code) }}</div>
        <div class="sheet-row"><b>Tipo:</b> {{ safeValue(vehicle.type) }}</div>
        <div class="sheet-row"><b>Departamento:</b> {{ safeValue(vehicle.departament) }}</div>
        <div class="sheet-row"><b>Resguardo:</b> {{ safeValue(getCurrentPerson()) }}</div>
        <div class="sheet-row"><b>Marca / Modelo:</b> {{ safeValue(vehicle.brand) }} {{ safeValue(vehicle.model) }}</div>
        <div class="sheet-row"><b>Color:</b> {{ safeValue(vehicle.color) }}</div>
        <div class="sheet-row"><b>Serie:</b> {{ safeValue(vehicle.serie) }}</div>
        <div class="sheet-row"><b>Motor:</b> {{ safeValue(vehicle.motor) }}</div>
        <div class="sheet-row"><b>Placas:</b> {{ safeValue(vehicle.plates) }}</div>
        <div class="sheet-row"><b>No. Economico:</b> {{ safeValue(vehicle.economic_number) }}</div>
        <div class="sheet-row"><b>Fecha de adquisicion:</b> {{ vehicle.adquisition_date | date }}</div>
        <div class="sheet-row"><b>Valor:</b> ${{ (vehicle.adquisition_value || 0) | currency }}</div>
        <div class="sheet-row"><b>Comodato:</b> {{ safeValue(vehicle.comodato) }}</div>
        <div class="sheet-row"><b>Observaciones:</b> {{ safeValue(vehicle.observations) }}</div>
      </CCol>
    </CRow>

    <template #footer>
      <CButton color="info" @click="printRecord">Imprimir</CButton>
      <CButton color="secondary" @click="closeModal">Cerrar</CButton>
    </template>
  </CModal>
</template>

<script>
import ws from '../../services/vehicles'
import store from '../../store'

export default {
  name: 'VehicleProfileModal',
  data () {
    return {
      showModal: false,
      vehicle: {},
      images: [],
      activeImageUrl: '',
      activeImageId: 0
    }
  },
  computed: {
    hasImages () {
      return this.images.length > 0
    }
  },
  methods: {
    openModal (item) {
      this.vehicle = item || {}
      this.images = this.parseImages(item)
      this.setActiveImage(this.images.length > 0 ? this.images[0] : null)
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
      this.vehicle = {}
      this.images = []
      this.activeImageUrl = ''
      this.activeImageId = 0
    },
    async printRecord () {
      if (!this.vehicle || !this.vehicle.id) {
        store.commit('toast', { color: 'warning', message: 'No se encontro el registro para imprimir.' })
        return
      }

      await ws.downloadProfileSheet({ id: this.vehicle.id })
    },
    setActiveImage (image) {
      if (!image) {
        this.activeImageUrl = ''
        this.activeImageId = 0
        return
      }

      this.activeImageUrl = image.url || ''
      this.activeImageId = image.id || 0
    },
    async deleteImage (id) {
      if (!id) {
        return
      }

      if (!window.confirm('Estas seguro que deseas eliminar esta foto?')) {
        return
      }

      const response = await ws.deleteImage({ id: id })
      if (response.type === 'success') {
        this.images = this.images.filter((item) => item.id !== id)
        this.setActiveImage(this.images.length > 0 ? this.images[0] : null)
        store.commit('toast', { color: 'success', message: response.message })
        this.$emit('updated')
        return
      }

      store.commit('toast', { color: response.type, message: response.message })
    },
    parseImages (item) {
      const imageList = []

      const pushImage = (value, id = 0) => {
        if (!value) {
          return
        }

        let url = value

        if (typeof value === 'object') {
          url = value.filename || value.image || ''
        }

        if (!url || url === 'null') {
          return
        }

        if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
          let path = String(url).replace(/^\/+/, '')

          if (path.indexOf('uploads/') !== 0) {
            path = 'uploads/vehicles/image/' + path
          }

          url = 'https://patrimonial.s3.us-west-2.amazonaws.com/' + path
        }

        if (imageList.findIndex((item) => item.url === url) === -1) {
          imageList.push({ id: id, url: url })
        }
      }

      if (!item) {
        return imageList
      }

      if (Array.isArray(item.images)) {
        item.images.forEach((image) => pushImage(image, image.id || 0))
      }

      return imageList
    },
    getCurrentPerson () {
      if (this.vehicle && this.vehicle.person) {
        return this.vehicle.person
      }

      if (this.vehicle && Array.isArray(this.vehicle.allocations) && this.vehicle.allocations.length > 0) {
        const allocation = this.vehicle.allocations[0]
        if (allocation && allocation.person && allocation.person.name) {
          return allocation.person.name
        }
      }

      return ''
    },
    safeValue (value) {
      if (value === null || value === undefined || value === '') {
        return 'N/A'
      }

      return value
    }
  }
}
</script>

<style scoped>
.image-viewer {
  border: 1px solid #d7d7d7;
  border-radius: 6px;
  padding: 8px;
  background: #fafafa;
}

.main-image {
  width: 100%;
  max-height: 360px;
  object-fit: contain;
  border-radius: 4px;
  background: #fff;
}

.thumbs {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  overflow-x: auto;
}

.thumb-btn {
  border: 2px solid transparent;
  background: transparent;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
}

.thumb-btn img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.thumb-btn.active {
  border-color: #2c7be5;
}

.empty-photos {
  min-height: 360px;
  border: 1px dashed #c9c9c9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  padding: 16px;
  text-align: center;
}

.sheet-row {
  border-bottom: 1px solid #efefef;
  padding: 6px 0;
  font-size: 13px;
}

.section-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}
</style>
